// src/components/MembershipMoto.js
import React from "react";
import { Card } from "react-bootstrap";

const MembershipMoto = () => {
  return (
    <Card className="shadow-lg border-0 rounded-3">
      <Card.Body className="p-4">
        {/* Title */}
        <h4 className="fw-bold text-primary text-center mb-4">
          Membership Expectations
        </h4>

        {/* Subtitle */}
        <p className="text-muted text-center mb-4" style={{ fontSize: "15px" }}>
          All applicants for membership of the{" "}
          <strong>Manav Adhikar Forum</strong> are expected to uphold the
          following values:
        </p>

        {/* Expectations List */}
        <ul className="list-unstyled">
          <li className="d-flex align-items-start mb-3">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>Demonstrate a genuine interest in human rights issues.</span>
          </li>

          <li className="d-flex align-items-start mb-3">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>
              Act in ways that respect the dignity and rights of all
              individuals.
            </span>
          </li>

          <li className="d-flex align-items-start mb-3">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>Support the Forum’s activities and objectives.</span>
          </li>

          <li className="d-flex align-items-start mb-3">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>
              Adhere to the Forum’s ethical guidelines and code of conduct.
            </span>
          </li>

          <li className="d-flex align-items-start mb-3">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>
              Donating members will be granted membership provided they also
              uphold the Forum's rules and values.
            </span>
          </li>

          <li className="d-flex align-items-start mb-2">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>
              Financial contributions are used to fund advocacy campaigns,
              educational programs, and direct aid initiatives for human rights.
            </span>
          </li>

          <li className="d-flex align-items-start mb-2">
            <span className="text-success me-2" style={{ fontSize: "1.2rem" }}>
              ✔
            </span>
            <span>
              Understand that the Forum reserves the right to accept or reject
              membership applications based on its established criteria and
              governing documents.
            </span>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default MembershipMoto;
